import { createElement } from 'react';

import { financeRoutePaths } from './paths';
import { LegacyFinanceRedirect } from './LegacyFinanceRedirect';

import type { RouteObject } from 'react-router-dom';

/**
 * TRAD-3867 — 인사이트 섹션(10/30 `/finance` → `/insights` — paths.ts).
 * 목록 = 카테고리 칩 + 글 목록(서버) + 관계 지도·표(정적 그림, 프리렌더) · 상세 = backend 콘텐츠 API(계약 v6) — 프리렌더 대상 아님(nginx 색인 가능 셸).
 */
export const financeRoute: RouteObject = {
  path: financeRoutePaths.finance.path,
  async lazy() {
    const Page = await import('@/pages/finance-relations/ListPage');
    return { Component: Page.default };
  },
};

export const financeContentRoute: RouteObject = {
  path: financeRoutePaths.financeContent.path,
  async lazy() {
    const Page = await import('@/pages/finance-content/DetailPage');
    return { Component: Page.default };
  },
};

/** 관계 지도·표 — 정적 그림(프리렌더 · STATIC_ROUTES). */
export const financeRelationsRoute: RouteObject = {
  path: financeRoutePaths.financeRelations.path,
  async lazy() {
    const Page = await import('@/pages/finance-relations/RelationsPage');
    return { Component: Page.default };
  },
};

/** 공유(캡처) 카드 — router.tsx 에서 MainLayout «밖»(RootLayout 직속)에 둔다. */
export const financeShareCardRoute: RouteObject = {
  path: financeRoutePaths.financeShareCard.path,
  async lazy() {
    const Page = await import('@/pages/finance-content/ShareCardPage');
    return { Component: Page.default };
  },
};

/**
 * TRAD-3921 — 영어판 주소 `/en/insights…`. 한국어 주소와 «같은 화면 컴포넌트»를 쓴다(주소에서 언어를 읽는다 — paths.ts).
 * 순서·자리도 한국어 쪽과 같다: 목록·관계·상세는 MainLayout 안, 공유 카드는 밖.
 * 🔴 하나씩 `…Route` 이름으로 export 한다 — 상세 화면 가드(detail-back-button-coverage.test.ts)가 `Route` 로 끝나는 export 에서 모수를 뽑는다.
 *    배열(`…Routes`)로만 내보내면 그 가드가 영어 상세 라우트를 못 본다(전체 스위트에서 실제로 그렇게 걸렸다).
 */
export const financeEnRoute: RouteObject = { ...financeRoute, path: financeRoutePaths.financeEn.path };

export const financeRelationsEnRoute: RouteObject = {
  ...financeRelationsRoute,
  path: financeRoutePaths.financeRelationsEn.path,
};

export const financeContentEnRoute: RouteObject = { ...financeContentRoute, path: financeRoutePaths.financeContentEn.path };

/** router.tsx 가 펼쳐 넣는 묶음(MainLayout 안 3개 — 순서는 한국어 쪽과 같다). */
export const financeEnRoutes: RouteObject[] = [financeEnRoute, financeRelationsEnRoute, financeContentEnRoute];

export const financeShareCardEnRoute: RouteObject = {
  ...financeShareCardRoute,
  path: financeRoutePaths.financeShareCardEn.path,
};

/** dev 에만 있던 `/finance`·`/finance/:slug` → `/insights` 같은 자리(쿼리·해시 유지). */
export const legacyFinanceRoutes: RouteObject[] = [
  { path: financeRoutePaths.legacyFinance.path, element: createElement(LegacyFinanceRedirect) },
  { path: financeRoutePaths.legacyFinanceContent.path, element: createElement(LegacyFinanceRedirect) },
];
